import Ext from 'Ext'
import $ from 'jquery'
import messageResource from '../../messageResource'
import BalanceType from '../../enums/BalanceType'
import {LeaveBalanceCorrectionType, LeaveBalanceUnits} from 'constants'
import NumberFormatter from '../../number_formatter'
import DropdownDialog from '../../controls/DropdownDialog'
import {KEY_CODE_ENTER} from '../../keyCodes'
import DecimalField from '../../controls/DecimalField'
import {getStringWithUnifiedNewLineSymbol} from '../../atUtils'
import ElasticTextArea from '../../controls/at_elastic_textarea'

/**
 * Requires: DropdownDialog.js, at_elastic_textarea.js, smart_field.js, system_settings_js.jsp,
 *           jquery_rpc.js, message_resources.js with 'leave_balance_editor' & 'common' prefixes
 * Markup: leave_balance_editor.jsp
 *
 * @author kostenko
 *
 * @name LeaveBalanceCorrectionType defined in constants_js.jsp
 * @name LeaveBalanceCorrectionType.SET
 * @name LeaveBalanceCorrectionType.ADD
 * @name LeaveBalanceCorrectionType.SUB
 * @name LeaveBalanceUnits defined in constants_js.jsp
 * @name LeaveBalanceUnits.DAYS
 * @name LeaveBalanceUnits.HOURS
 * @name SystemSettings defined in system_settings_js.jsp
 * @name SystemSettings.decimalSeparator
 * @name SystemSettings.showPTOInHours
 * @name SystemSettings.showSickInHours
 */
function LeaveBalanceEditor(element) {
    var MAX_FRACTION_DIGITS = 2;
    var MAX_COMMENT_LENGTH = 2000;

    this.show = function(element, baseValueInDays, userName, ptoHoursPerDay, balanceType) {
        setCorrectionMode(LeaveBalanceCorrectionType.SET);
        currentPtoHoursPerDay = ptoHoursPerDay;
        currentBalanceType = balanceType;
        var showBalanceInHours = balanceType == BalanceType.PTO ? window.SystemSettings.showPTOInHours : window.SystemSettings.showSickInHours;
        setUnits(showBalanceInHours ? LeaveBalanceUnits.HOURS : LeaveBalanceUnits.DAYS);
        currentUserName = userName;

        hardValueField.setValueAsNumber(recalculateValueFrom(LeaveBalanceUnits.DAYS, baseValueInDays));

        contentDiv.find(".inDaysMode .baseValue").text(formatter.format(baseValueInDays));
        contentDiv.find(".inHoursMode .baseValue").text(formatter.format(daysToHours(baseValueInDays)));

        relativeValueField.setValue('');
        relativeValueField.clearValidationResult(); // don't highlight although it's empty, only highlight on apply

        hideError();

        $(commentsArea.textarea.dom).pVal("");

        this.busyModeOff();
        dropdownDialog.showAt(element, {my: "left top", at: "left top"});
        focusField();
        commentsArea.fitToHeight();
    };

    this.hide = function() {
        this.busyModeOff();
        dropdownDialog.hide();
    };

    this.busyModeOff = function() {
        applyButton.prop('disabled', false);
        applyButton.removeClass('savingMode');
        dropdownDialog.allowClose();
    };

    this.showCapExceededError = function(capInDays) {
        this.busyModeOff();
        var key;
        if (currentBalanceType == BalanceType.PTO)
            key = units == LeaveBalanceUnits.DAYS ? "common.pto_error.cap_exceeded.days" : "common.pto_error.cap_exceeded.hours";
        else
            key = units == LeaveBalanceUnits.DAYS ? "common.sick_error.cap_exceeded.days" : "common.sick_error.cap_exceeded.hours";
        var value = formatter.format(recalculateValueFrom(LeaveBalanceUnits.DAYS, capInDays));
        blinkError(messageResource.getMessage(key, [value]));
    };

    /**
     * @param callback function( correctionType, valueInDays, comment )
     */
    this.setOnApplyCallback = function(callback) {
        onApplyCallback = callback;
    };

    this.setOnCloseCallback = function(callback) {
        onCloseCallback = callback;
    };

    var correctionType;
    var units;
    var contentDiv = element;
    var applyButton = contentDiv.find(".applyButton");
    var onApplyCallback;
    var onCloseCallback;
    var formatter = new NumberFormatter(window.SystemSettings.decimalSeparator, null, MAX_FRACTION_DIGITS, true);
    var currentUserName;
    var currentPtoHoursPerDay;
    var currentBalanceType;

    var balanceCorrectionMenu = new Ext.menu.Menu({
        items: [
            {
                text: messageResource.getMessage("leave_balance_editor.set_hard_value"),
                cls: "hard",
                listeners: {
                    click: function() {
                        setCorrectionMode(LeaveBalanceCorrectionType.SET);
                    }
                }
            },
            {
                text: messageResource.getMessage("leave_balance_editor.increase"),
                cls: "increase",
                listeners: {
                    click: function() {
                        setCorrectionMode(LeaveBalanceCorrectionType.ADD);
                    }
                }
            },
            {
                text: messageResource.getMessage("leave_balance_editor.decrease"),
                cls: "decrease",
                listeners: {
                    click: function() {
                        setCorrectionMode(LeaveBalanceCorrectionType.SUB);
                    }
                }
            }
        ],
        cls: "at-dropdown-list-btn-menu leaveBalanceEditorMode"
    });

    contentDiv.find('.correctionTypeButton').click(function() {
        balanceCorrectionMenu.show(this);
    });

    var hardValueErrorText = messageResource.getMessage('common.js.invalid_number', window.SystemSettings.decimalSeparator);
    var relativeValueErrorText = messageResource.getMessage('common.js.invalid_number.positive', window.SystemSettings.decimalSeparator);

    var hardValueField =
        new DecimalField(contentDiv.find('.hardValueField'), false, 7, MAX_FRACTION_DIGITS,
            window.SystemSettings.decimalSeparator, true, window.SystemSettings.digitGroupingSymbol,
            hardValueErrorText);
    var relativeValueField =
        new DecimalField(contentDiv.find('.relativeValueField'), false, 7, MAX_FRACTION_DIGITS,
            window.SystemSettings.decimalSeparator, false, window.SystemSettings.digitGroupingSymbol,
            relativeValueErrorText, false);

    contentDiv.find('.hardValueField').keypress(field_keypress);
    contentDiv.find('.relativeValueField').keypress(field_keypress);

    contentDiv.find(".daysButton").click(function() {
        setUnits(LeaveBalanceUnits.DAYS);
    });

    contentDiv.find(".hoursButton").click(function() {
        setUnits(LeaveBalanceUnits.HOURS);
    });

    applyButton.click(apply);

    var that = this;
    var dropdownDialog = new DropdownDialog({
        dialogDiv: contentDiv,
        hideButtons: true,
        wrapperClass: 'leaveBalanceEditor customPopup',
        showEmptyTitleBar: true,
        hideOnResize: true,
        onClose: function() {
            if (onCloseCallback) onCloseCallback();
        }
    });

    var commentsArea =
        new ElasticTextArea({textarea: contentDiv.find(".comments")[0], expandMin: 19, expandMax: 200});
    $(commentsArea.textarea.dom).placeholder();

    function field_keypress(event) {
        if (event.keyCode == KEY_CODE_ENTER) {
            apply();
            return false;
        }

        return true;
    }

    function setCorrectionMode(mode) {
        balanceCorrectionMenu.hide();
        correctionType = mode;
        contentDiv.toggleClass('hardValueMode', correctionType == LeaveBalanceCorrectionType.SET);
        contentDiv.toggleClass('increaseValueMode', correctionType == LeaveBalanceCorrectionType.ADD);
        contentDiv.toggleClass('decreaseValueMode', correctionType == LeaveBalanceCorrectionType.SUB);
        focusField();
    }

    function setUnits(newUnits) {
        var oldUnits = units;
        units = newUnits;

        contentDiv.toggleClass('daysMode', units == LeaveBalanceUnits.DAYS);
        contentDiv.toggleClass('hoursMode', units == LeaveBalanceUnits.HOURS);

        recalculateFieldFrom(oldUnits, hardValueField);
        recalculateFieldFrom(oldUnits, relativeValueField);
    }

    function recalculateFieldFrom(oldUnits, field) {
        if (field.isValid())
            field.setValueAsNumber(recalculateValueFrom(oldUnits, field.getValueAsNumber()));
    }

    function recalculateValueFrom(oldUnits, value) {
        if (oldUnits == LeaveBalanceUnits.DAYS && units == LeaveBalanceUnits.HOURS)
            return daysToHours(value);

        if (oldUnits == LeaveBalanceUnits.HOURS && units == LeaveBalanceUnits.DAYS)
            return hoursToDays(value);

        return value;
    }

    function daysToHours(days) {
        return days * currentPtoHoursPerDay;
    }

    function hoursToDays(hours) {
        return hours / currentPtoHoursPerDay;
    }

    function focusField() {
        if (correctionType == LeaveBalanceCorrectionType.SET)
            hardValueField.focus();
        else
            relativeValueField.focus();
    }

    function blinkError(message) {
        contentDiv.find('.errorTextCell').text(message);
        contentDiv.addClass('errorState').addClass('blinkError');

        setTimeout(function() { contentDiv.removeClass('blinkError') }, 200);
    }

    function hideError() {
        contentDiv.removeClass('errorState');
    }

    function apply() {
        var comment = $.trim($(commentsArea.textarea.dom).pVal());

        $(commentsArea.textarea.dom).pVal(comment);
        commentsArea.fitToHeight();

        var field = correctionType == LeaveBalanceCorrectionType.SET ? hardValueField : relativeValueField;

        field.process();

        if (field.isValid()) {
            var commentLength = getStringWithUnifiedNewLineSymbol(comment).length;

            if (commentLength <= MAX_COMMENT_LENGTH) {
                applyButton.prop('disabled', true);
                applyButton.addClass('savingMode');
                dropdownDialog.preventClose();

                var value = field.getValueAsNumber();

                if (units == LeaveBalanceUnits.HOURS)
                    value = hoursToDays(value);

                if (onApplyCallback)
                    onApplyCallback(correctionType, value, comment);
            }
            else {
                blinkError(messageResource.getMessage("common.pto_error.comments_too_long",
                    [MAX_COMMENT_LENGTH, commentLength]));
            }
        }
        else {
            blinkError(field == hardValueField ? hardValueErrorText : relativeValueErrorText);
        }
    }
}

export default LeaveBalanceEditor



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/LeaveBalanceEditor.js